module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fullwidth",
    attrs: {
      "id": "nav"
    }
  }, [_c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('button', {
    staticClass: "navbar-toggle mobile-hamburger",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbar",
      "aria-expanded": "true",
      "aria-controls": "navbar"
    },
    on: {
      "click": function($event) {
        _vm.store.mobileNavShow = !_vm.store.mobileNavShow
      }
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Navigation")]), _c('span', {
    staticClass: "icon-bar"
  }), _c('span', {
    staticClass: "icon-bar"
  }), _c('span', {
    staticClass: "icon-bar"
  })]), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "display": "inline-block",
      "height": "30px"
    },
    attrs: {
      "src": require("../assets/vsphere-connect-logo-sm.png")
    }
  }), _c('span', [_vm._v("  vSphere Connect")])])], 1), _c('div', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "id": "navbar"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/faq"
    }
  }, [_vm._v("faq")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/docs"
    }
  }, [_vm._v("docs")])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/api"
    }
  }, [_vm._v("api")])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98741c5e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navbar.vue
// module id = 169
// module chunks = 1